import React, { useState } from 'react';
import logo from '../assets/SDP_Logo.png';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
      if (username === 'dental' && password === 'dentalforyou') {
          onLogin(username);
      } else if (username === 'dso' && password === 'dsoforyou') {
          onLogin(username);
      } else if (username === 'vet' && password === 'vetforyou') {
          onLogin(username);
      } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
              <div className="login-boxInner">
        <div className="login-header mt-2">
                      <img src={logo} alt="Self-Driving Practice" className="logo" />
                      <div className="webtxt">Welcome Back</div>
        </div>
        <form onSubmit={(e)=> handleSubmit(e)}>
          <div className="form-group">
            <label>Enter Your Username *</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
            />
          {/*  <a href="#" className="forgot-link">Forgot Username?</a>*/}
          </div>
          <div className="form-group">
            <label>Enter Your Password *</label>
            <div className="password-input">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
              />
              <button 
                type="button" 
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                <i className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}></i>
              </button>
            </div>
           {/* <a href="#" className="forgot-link">Forgot Password?</a>*/}
          </div>
          <div className="remember-me">
            <input
              type="checkbox"
              id="remember"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label htmlFor="remember">Remember my username</label>
          </div>
          {error && <div className="error">{error}</div>}
          <button type="submit" className="login-btn">Sign In</button>
        </form>
                  <div className="register-link fw-bold">
                      Don't have an account? <a href="https://sikka.ai/SelfDrivingPractice" target="_blank" rel="noreferrer">Register</a>
        </div>
        <div className="warning-box">
     
                      <p><strong>Warning: <i className="fas fa-exclamation-circle"></i></strong> This system is for the use of authorized users only. Individuals using this application without authority, or in excess of their authority, are subject to having all of their activities on this system monitored and recorded.</p>
        </div>
      </div>
      </div>
      <footer className="login-page-footer">
        <p>© 2026 Sikka Software Corporation | Leading AI infrastructure as a Service (AIaaS) for Retail Healthcare | All Rights Reserved | Support</p>
      </footer>
    </div>
  );
};

export default Login;
